import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefaufgabe-aktualisieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefaufgabeAktualisierenEffects {

    PruefaufgabeAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFAUFGABE_AKTUALISIEREN),
        mergeMap((x: ac.PostPruefaufgabeAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefaufgabeAktualisieren(x.pruefaufgabeModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefaufgabeAktualisierenErfolgreichAction(result, x.pruefaufgabeModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefaufgabeAktualisierenFehlerAction(error, x.pruefaufgabeModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
